module.exports = __webpack_public_path__ + "static/media/IMG_20200417_185624.1f47f5e8.jpg";